import { MouseEvent, ReactElement } from 'react';
import { useRouterPush } from '@client/routes/hooks';
import { openLink } from '@client/routes/utils/url';
import { Props } from './';
import './Banner.scss';

export const Banner = ({ image, url }: Props): ReactElement => {
  const push = useRouterPush();
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    url && openLink(url, push, e);
  };
  const content = <img alt='Banner' src={image} className='cds-ImgFluid' />;

  return (
    <div className="ProductDescription-Banner">
      {url
        ? (
          <a
            href={url}
            onClick={handleClick}
            target="_blank"
            rel="noopener noreferrer"
          >
            {content}
          </a>
        )
        : content
      }
    </div>
  );
};
